import { RouteRecordRaw } from 'vue-router';
import { UserRole, USER_TYPE } from '@/common/constants';

/**
 * @deprecated Importer UserRole depuis '@/common/constants' directement
 */
export { UserRole } from '@/common/constants';

/**
 * Catégories de routes : reprend les types utilisateur + COMMON.
 * Utilisé dans AppRouteMeta.category pour catégoriser les routes dans les menus.
 */
export const ROUTE_CATEGORY = {
  ...USER_TYPE,
  COMMON: 'Common',
} as const;

export type RouteCategoryValue = (typeof ROUTE_CATEGORY)[keyof typeof ROUTE_CATEGORY];

/**
 * Métadonnées étendues pour les routes
 */
export interface AppRouteMeta {
  requiresRole?: UserRole;
  title?: string;
  icon?: string;
  hideInMenu?: boolean;
  category?: RouteCategoryValue;
}

/**
 * Configuration pour la construction de routes par rôle
 */
export interface RouteConfig {
  role: UserRole;
  homeRoute: string;
  routes: RouteRecordRaw[];
}
